module.exports = __webpack_public_path__ + "img/avatar_random_1.52f1574c.png";